import React, { useEffect, useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { useSelector } from "react-redux";
import {
  Button,
  Card,
  Col,
  Form,
  Row,
  TabContent,
  TabPane,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  FormText,
  FormFeedback,
} from "reactstrap";
import * as actions from "../../store/modules/usuario/actions";
import Search from "./tabs/search";
import Register from "./tabs/register";
import * as usuarioControllers from "../../controllers/usuarioController";
import Breadcrumb from "../../components/breadcrumbs";
import { notifyWarn } from "../../components/message/message";

const Usuario = () => {
  const {
    item,
    copy,
    activeTab,
    seeRegister,
    verifyPass,
    changePass,
    passwords,
    permitions,
  } = useSelector((state) => state.usuario);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [observation, setObservation] = useState("");
  const [validationError, setValidationError] = useState("");

  useEffect(() => {
    actions.setActiveTab("Search");
  }, []);

  const validateObservation = () => {
    if (!observation.trim()) {
      setValidationError("Este campo é obrigatório.");
      return false;
    }
    if (observation.length > 120) {
      setValidationError("Observação deve ter até 120 caracteres");
      return false;
    }
    setValidationError("");
    return true;
  };

  function changeTab(tab) {
    actions.setActiveTab(tab);
    actions.cleanRegister();
  }

  function seeRegisterF() {
    if (item.id !== "") {
      actions.cleanRegister();
    }
    actions.setSeeRegister(false);
  }

  async function handleVoltar() {
    changeTab("Search");
    seeRegisterF();
    usuarioControllers.getAll(0, 10, {
      cpf: "",
      email: "",
      nome: "",
    });
    actions.cleanSearch();
  }

  async function saveItem() {
    if (!validateObservation()) return;

    try {
      let response = null;

      const dataToSave = {
        ...item,
        observacao: observation.trim(),
      };

      if (item.id !== "") {
        if (changePass && JSON.stringify(item) === JSON.stringify(copy)) {
          response = await usuarioControllers.updatePass(
            item.id,
            passwords,
            observation.trim()
          );
        } else if (JSON.stringify(item) !== JSON.stringify(copy)) {
          response = await usuarioControllers.update(dataToSave, copy);

          if (response?.success && changePass) {
            response = await usuarioControllers.updatePass(
              item.id,
              passwords,
              observation.trim()
            );
          }
        }
      } else {
        response = await usuarioControllers.create(dataToSave, passwords);
      }

      if (response?.success) {
        setObservation("");
        actions.setActiveTab("Search");
        actions.cleanSearch();
        setIsModalOpen(false);
        usuarioControllers.getAll(0, 10, {
          cpf: "",
          email: "",
          nome: "",
        });
      }
    } catch (error) {
      console.error("Erro ao salvar:", error);
    }
  }

  return (
    <>
      <Col>
        <Breadcrumb activeTab={activeTab} />

        <Card>
          <Form>
            {activeTab === "Search" ? (
              permitions.criar && (
                <Col md={12}>
                  <Row className="pt-2 pb-2">
                    <Col md={8}>
                      <Button
                        onClick={() => changeTab("Register")}
                        style={{ width: "210px" }}
                        className="purpleButton"
                      >
                        Cadastrar Usuário
                      </Button>
                    </Col>
                  </Row>
                </Col>
              )
            ) : (
              <Col className="pt-2 pb-2">
                <Button
                  onClick={() => {
                    handleVoltar();
                  }}
                  style={{ width: "150px", color: "white" }}
                  className="purpleButton"
                >
                  <IoIosArrowBack style={{ marginTop: "3px", float: "left" }} />{" "}
                  Voltar
                </Button>
                {!seeRegister && (
                  <Button
                    onClick={() => setIsModalOpen(true)}
                    style={{ width: "242px", float: "right" }}
                    className="purpleButton"
                  >
                    Salvar Cadastro
                  </Button>
                )}
              </Col>
            )}
          </Form>
        </Card>
      </Col>

      <TabContent style={{ width: "100%" }} activeTab={activeTab}>
        <TabPane tabId="Search">
          <br />
          <Search />
        </TabPane>
        <TabPane tabId="Register">
          <br />
          <Register />
        </TabPane>
      </TabContent>

      {/* Modal de Confirmação */}
      <Modal
        isOpen={isModalOpen}
        toggle={() => {
          setObservation("");
          setIsModalOpen(false);
        }}
        centered
        size="md"
        backdrop="static"
      >
        <ModalHeader
          toggle={() => {
            setObservation("");
            setIsModalOpen(false);
          }}
          className="border-0 pb-1"
        >
          <h5 className="mb-0 fw-bold">
            Tem certeza que deseja alterar esse(s) item(s)?
          </h5>
        </ModalHeader>

        <ModalBody className="pt-1">
          <div className="mb-3">
            <p className="text-muted mb-4">
              Esta ação irá alterar o(s) item(s) selecionado(s).
              <br />
              <strong>Confirme a operação com uma observação:</strong>
            </p>

            <FormGroup className="mb-3">
              <Input
                type="textarea"
                placeholder="Digite uma observação obrigatória"
                value={observation}
                onChange={(e) => {
                  setObservation(e.target.value);
                  if (validationError) setValidationError("");
                }}
                className={`rounded-2 ${validationError ? "is-invalid" : ""}`}
                style={{
                  minHeight: "100px",
                  resize: "vertical",
                }}
                maxLength={120}
              />
              <div className="d-flex justify-content-between mt-2">
                <FormText color="muted">Máximo 120 caracteres</FormText>
                <FormText
                  color={observation.length === 120 ? "danger" : "muted"}
                >
                  {observation.length}/120
                </FormText>
              </div>
              {validationError && (
                <FormFeedback>{validationError}</FormFeedback>
              )}
            </FormGroup>
          </div>

          <div className="m-3 d-flex justify-content-center">
            <Button
              color="danger"
              style={{ width: "100px", marginRight: "15px" }}
              onClick={() => {
                setObservation("");
                setIsModalOpen(false);
              }}
            >
              Cancelar
            </Button>
            <Button
              onClick={saveItem}
              style={{
                width: "100px",
                marginLeft: "15px",
                background: "var(--color-verde)",
                border: "none",
              }}
            >
              Confirmar
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default Usuario;
